import api from 'api';

export const getWhatsappMessages = (params, extraHeaders) => {
  return api.get('/whatsapp_messages', params, 'bearer', extraHeaders);
};

export const getWhatsappMessage = (id, params) => {
  return api.get(`/whatsapp_messages/${id}`, params, 'bearer');
};
